export default "__VITE_ASSET__BjMpi2Mu__"